import { React, useState, useEffect, Suspense } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Col, Row, Container, Modal, Button } from "react-bootstrap";

import "./ClassOverview.css";
import "./SencoReportsOverview.css";

import GradeCard from "./GradeCard";
import ReturnToResults from "./ReturnToResults";
import PrintSencoReports from "./PrintSencoReports";
import SencoReportClassTable from "./SencoReportClassTable";
import ExpandedSencoReportView from "./ExpandedSencoReportView";
import SENWatchlistTable from "./SENWatchlistTable";
import CloseButton from "./BackButton";
import ShareActionCard from "./ShareActionCard";
import SENShareActionCard from "./SENShareActionCard"; // Import SENShareActionCard
import ExpandedSENWatchlistView from "./ExpandedSENWatchlistView"; // Import ExpandedSENWatchlistView

import {
  getResultsByStudent,
  getReportOptions,
  getSenStudents,
} from "../services/APIClient";
import PrintSENWatchlist from "./PrintSENWatchlist";

function SENWatchlistOverview(props) {
  const {
    students,
    selectedYear,
    yearRange,
    classDetails,
    classid,
    classAssessments,
    teachers,
    teacherid,
    assessment,
    readingScores,
    studentsReadingScore,
    schoolid,
  } = props;

  const [assessmentResultsByStudent, setAssessmentResultsByStudent] = useState(
    []
  );
  const [reportOptions, setReportOptions] = useState("");
  const [showExpandedModal, setShowExpandedModal] = useState(false);
  const [studentsReadingScores, setStudentsReadingScores] = useState([]);
  const [sortCriteria, setSortCriteria] = useState({
    field: null,
    order: null,
  });
  const [showAtRiskOnly, setShowAtRiskOnly] = useState(false);
  const [showSortedData, setShowSortedData] = useState(false);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [showShareCard, setShowShareCard] = useState(false); // State for SENShareActionCard
  const [shareCardPosition, setShareCardPosition] = useState({
    top: 0,
    left: 0,
  });
  const [expandedViewData, setExpandedViewData] = useState({
    students: [],
  }); // Initialize with an empty structure

  const handleShowExpandedModal = () => setShowExpandedModal(true);
  const handleCloseExpandedModal = () => setShowExpandedModal(false);
  const handleShowSortedData = (data) => {
    setShowSortedData(data);
  };
  const handleExpandedViewData = (data) => {
    setExpandedViewData(data || { students: [] }); // Ensure data is not null
  };

  useEffect(() => {
    if (assessment && assessment.instances) {
      getResultsByStudent(assessment.instances).then((response) => {
        setAssessmentResultsByStudent(response);
      });
    }
  }, [assessment]);

  useEffect(() => {
    getReportOptions(false).then((response) => {
      setReportOptions(response);
    });
  }, []);

  useEffect(() => {
    if (selectedYear && yearRange) {
      const { start, end } = yearRange;
      const startDate = new Date(start);
      const endDate = new Date(end);

      // Filter students based on dateCreated
      const filtered = students.filter((student) => {
        if (!student.dateCreated) return false; // Skip if dateCreated is missing
        const dateCreated = new Date(student.dateCreated);
        return dateCreated >= startDate && dateCreated <= endDate;
      });

      setFilteredStudents(filtered);
    }
  }, [students, selectedYear, yearRange]);

  return (
    <>
      <Row className="inline-block align-items-center push-down mt-4">
        <Col className="col-auto">
          <Suspense fallback={<div>Loading Navigation Button...</div>}>
            <CloseButton />
          </Suspense>
        </Col>
        <Col className="flex-grow-1 text-center" style={{ margin: "10px" }}>
          <h2 className="page-description-header-results">SEN Watchlist</h2>
        </Col>
        <Col className="col-auto d-flex justify-content-end">
          <PrintSENWatchlist
            students={students}
            classDetails={classDetails}
            classid={classid}
            classAssessments={classAssessments}
            teachers={teachers}
            teacherid={teacherid}
            assessment={assessment}
            assessmentResultsByStudent={assessmentResultsByStudent}
            isPrintOut={false}
            sortCriteria={sortCriteria}
            showAtRiskOnly={showAtRiskOnly}
            setSortCriteria={setSortCriteria}
            setShowAtRiskOnly={setShowAtRiskOnly}
            studentsReadingScore={studentsReadingScore}
            showSortedData={showSortedData}
            onSortData={handleShowSortedData}
            schoolid={schoolid}
          />
          <button
            className="print-button"
            onClick={(event) => {
              const rect = event.currentTarget.getBoundingClientRect();
              setShareCardPosition({
                top: rect.top + window.scrollY,
                left: rect.left - 250,
              });
              setShowShareCard(!showShareCard); // Toggle SENShareActionCard
            }}
          >
            Share
            <img
              src={process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"}
              alt="Sort"
              className="print-button-icon"
            />
          </button>
        </Col>
        <Col className="col-auto"></Col>{" "}
        {/* Empty column to balance the layout */}
      </Row>
      <div className="class-overview-container">
        <Container className="container-shape">
          <Row className="page-description-bar">
            <Col className="col-6">
              <Row>
                <Col className="col-8">
                  <h2 className="page-description-header">SEN Watchlist</h2>
                </Col>
              </Row>
              <p>Use dropdown and edit buttons to generate a SENCO report</p>
            </Col>
            <Col className="col-4">
              <Row>
                <Col className="col-3"></Col>
                <Col className="col-4"></Col>
                <Col className="col-1"></Col>
                <Col className="col-4"></Col>

                <Col className="col-6"></Col>
              </Row>
            </Col>
          </Row>
          <hr></hr>
          <Row>
            <Col className="d-flex justify-content-end">
              <div
                className="recommendations-button"
                onClick={handleShowExpandedModal}
              >
                Expanded View
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  className="chevron-icon"
                >
                  <path
                    d="M3.34188 9.5L3.342 9C3.28547 8.99999 3.22661 8.98207 3.17272 8.94314C3.11827 8.90381 3.0703 8.84368 3.04059 8.76616C3.01081 8.68845 3.00253 8.60099 3.01812 8.51626C3.03368 8.43164 3.07131 8.35879 3.12091 8.30515C3.12093 8.30513 3.12094 8.30511 3.12096 8.30509L5.85956 5.34508L6.17373 5.00552L5.85956 4.66596L3.12091 1.7059L3.12096 1.70585L3.11496 1.69958C3.08137 1.66452 3.05262 1.62047 3.03217 1.56901C3.0117 1.51752 3.00048 1.46088 3.00002 1.40269C2.99955 1.34449 3.00986 1.28756 3.02955 1.23552C3.04923 1.18353 3.07739 1.13873 3.1106 1.10284C3.14373 1.06703 3.18095 1.04103 3.21895 1.02422C3.25682 1.00748 3.29586 0.999652 3.33419 1.00001C3.37252 1.00037 3.41155 1.00893 3.44935 1.02648C3.48728 1.04409 3.52429 1.07095 3.55703 1.10758L3.55697 1.10763L3.56285 1.11398L6.88944 4.70951C6.95636 4.78187 7 4.88775 7 5.00552C7 5.12326 6.95639 5.22912 6.88949 5.30148C6.88947 5.3015 6.88945 5.30152 6.88944 5.30154L3.56285 8.89706L3.5628 8.89712C3.49708 8.96818 3.41662 8.99998 3.34177 9L3.34188 9.5ZM3.34188 9.5C3.17742 9.49996 3.01666 9.44722 2.87993 9.34845C2.74319 9.24967 2.63663 9.1093 2.57369 8.94507L3.92986 9.23662C3.77393 9.40521 3.56243 9.49995 3.34188 9.5Z"
                    fill="#1C64F2"
                    stroke="#1C64F2"
                  />
                </svg>
              </div>
            </Col>
          </Row>
          <Row className="button-container">
            <Col className="col-12">
              <SENWatchlistTable
                students={filteredStudents}
                classDetails={classDetails}
                classAssessments={classAssessments}
                teachers={teachers}
                teacherid={teacherid}
                assessment={assessment}
                assessmentResultsByStudent={assessmentResultsByStudent}
                isPrintOut={false}
                sortCriteria={sortCriteria}
                showAtRiskOnly={showAtRiskOnly}
                setSortCriteria={setSortCriteria}
                setShowAtRiskOnly={setShowAtRiskOnly}
                studentsReadingScore={studentsReadingScore}
                setShowSortedData={setShowSortedData}
                onSortData={handleShowSortedData}
                showSortedData={showSortedData}
                readingScores={readingScores}
              />
            </Col>
          </Row>
          <Modal
            show={showExpandedModal}
            onHide={handleCloseExpandedModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="custom-modal-width senco-expandable-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Expanded View of SEN Watchlist
                <PrintSENWatchlist
                  students={students}
                  classDetails={classDetails}
                  classid={classid}
                  classAssessments={classAssessments}
                  teachers={teachers}
                  teacherid={teacherid}
                  assessment={assessment}
                  assessmentResultsByStudent={assessmentResultsByStudent}
                  isPrintOut={false}
                  sortCriteria={sortCriteria}
                  showAtRiskOnly={showAtRiskOnly}
                  setSortCriteria={setSortCriteria}
                  setShowAtRiskOnly={setShowAtRiskOnly}
                  studentsReadingScore={studentsReadingScore}
                  showSortedData={showSortedData}
                  onSortData={handleShowSortedData}
                  schoolid={schoolid}
                />
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ExpandedSENWatchlistView
                students={students}
                classDetails={classDetails}
                classid={classid}
                classAssessments={classAssessments}
                teachers={teachers}
                teacherid={teacherid}
                assessment={assessment}
                assessmentResultsByStudent={assessmentResultsByStudent}
                sortCriteria={sortCriteria}
                showAtRiskOnly={showAtRiskOnly}
                setSortCriteria={setSortCriteria}
                setShowAtRiskOnly={setShowAtRiskOnly}
                studentsReadingScore={studentsReadingScore}
                onSortData={handleShowSortedData}
                schoolid={schoolid}
                onDataReady={handleExpandedViewData} // Pass callback to capture data
              />
            </Modal.Body>
            <Modal.Footer>
              <button
                className="blue-action-button"
                onClick={handleCloseExpandedModal}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
          <Row>
            <Col className="results-buttons"></Col>
          </Row>
        </Container>
      </div>
      {showShareCard && (
        <SENShareActionCard
          cardPosition={shareCardPosition}
          handleCloseCard={() => setShowShareCard(false)}
          students={students} // Pass SEN Watchlist students
          className={classDetails?.name || "Class"}
          teacherId={teacherid}
          schoolId={schoolid}
          expandedViewData={expandedViewData} // Pass data from ExpandedSENWatchlistView
        />
      )}
    </>
  );
}

export default SENWatchlistOverview;
